import { combineReducers } from 'redux-immutable';

//将各个小的reducer整合为一个大的reducer统一管理
//reducer的拆分
import { reducer as appReducer } from './app';  //全局共用状态
import { reducer as loginReducer } from '../views/login/store';  //登录模块
import { reducer as homeReducer } from '../views/home/store';  //首页模块
import { reducer as electricActions } from '../views/data-find/components/electric/store';  //电表模块
import { reducer as gatewayActions } from '../views/data-find/components/gateway/store';  //电表模块
import { reducer as aisleLogActions } from '../views/aisle-log/store';  //首页模块
import { reducer as paramsReducer } from '../views/params-conf/store';  //参数配置
import { reducer as patchReducer } from '../views/patch-set/store';  //采集点配置

import { reducer as statisticalReducer } from '../views/statistical/store';  //统计分析


const reducer = combineReducers({
    app: appReducer,
    login: loginReducer,
    home: homeReducer,
    electric: electricActions,
    gateway: gatewayActions,
    aisleLog: aisleLogActions,
    params: paramsReducer,
    patch: patchReducer,
    statistical: statisticalReducer,
});

export default reducer;

// 注： 当通过 combineReducers 整合reducer时， 这里是一个对象， 那么reducer进而也会多一层
// 那么，在做数据映射时，mapStateToProps里也会多一层

// 所以：
//通过redux-immutable.js再次改造，全局store的state状态改为immutable对象,  可以通过改下方式获取
// state.getIn(["header","focused"]) 等价于
// state.get("header").get("focused")
